<script>

    export let stats;

</script>
{#if stats}

    {#if stats.length == 0}

        <div class='alert alert-info mb-3 clearfix'>
            <h4 class='float-start me-2'>
                <span class='fas fa-info-circle'></span>
            </h4>
            There are no results to display.
        </div>

    {:else}

        <div class='table-repsonsive'>
            <table class='table table-striped table-bordered table-hover'>
                <thead>
                    <tr>
                        <th class='col-1'>

                        </th>
                        <th class='col-5'>
                            Team
                        </th>
                        <th class='col-1'>
                            Played
                        </th>
                        <th class='col-1 text-center'>
                            Won
                        </th>
                        <th class='col-1 text-center'>
                            Lost
                        </th>
                        <th class='col-1 text-center'>
                            Draws
                        </th>
                        <th class='col-1 text-center'>
                            Sets Won
                        </th>
                        <th class='col-1 text-center'>
                            Sets Lost
                        </th>                        
                    </tr>
                </thead>
                <tbody>

                    {#each stats as s}

                        <tr>
                            <td>
                                {#if s.logo}

                                    <img src={s.logo} class='img-responsive' alt='Team Logo'/>

                                {/if}
                            </td>
                            <td>
                                
                                { s.name }

                            </td>
                            <td class='text-center'>
                                
                                { s.played }

                            </td>
                            <td class='text-center'>
                                
                                { s.won }

                            </td>
                            <td class='text-center'>
                                
                                { s.lost }

                            </td>
                            <td class='text-center'>
                                
                                { s.draws }

                            </td>
                            <td class='text-center'>
                                
                                {s.sets_won }

                            </td>
                            <td class='text-center'>
                                
                                { s.sets_lost }

                            </td>
                        </tr>

                    {/each}

                </tbody>
            </table>
        </div>

    {/if}

{/if}